/**
 * Türkçe mesaj kataloğu — **referans dil**.
 *
 * ⚠️ Her giriş **tam bir cümledir**. `t("joined") + name` gibi birleştirme
 *    yasaktır: Türkçede ek uyumu ("Ayşe'ye", "Ahmet'e") birleştirmeyle doğru
 *    çıkmaz.
 *
 * ⚠️ **Vaat dili bağlayıcıdır** (Rapor 08 §9):
 *    ❌ "uçtan uca şifreli" · ❌ "%100 doğru konuşmacı" · ❌ "canlı altyazı"
 */
export const tr = {
  // ── Genel ──────────────────────────────────────────────────────────────
  "app.name": "Centvox",
  "common.cancel": "Vazgeç",
  "common.close": "Kapat",
  "common.retry": "Tekrar dene",
  "common.loading": "Yükleniyor…",
  "common.copy": "Kopyala",
  "locale.label": "Arayüz dili",
  "a11y.skipToContent": "İçeriğe geç",
  "common.copied": "Kopyalandı",

  // ── Katılım ────────────────────────────────────────────────────────────
  // ── Karşılama (kök yol) ────────────────────────────────────────────────
  // ⚠️ Kök yol bir HATA DEĞİLDİR: Centvox hesapsızdır, girişi davet bağlantısı
  //    sağlar. Kırmızı hata bandı ürünün bozuk olduğunu düşündürüyordu.
  "landing.title": "Toplantıya katılmak için davet bağlantınız gerekiyor",
  "landing.body":
    "Centvox hesap açmadan çalışır. Size gönderilen bağlantıyı açtığınızda doğrudan toplantıya girersiniz.",
  "landing.hostHint":
    "Toplantı düzenleyicisiyseniz yönetim panelinden bağlantı oluşturabilirsiniz.",

  // ── Tanıtım sayfası (kök yol) ──────────────────────────────────────────
  // ⚠️ VAAT DİLİ BURADA EN SIKI DENETLENİR (Rapor 08 §9). Bu metinler ürünün
  //    satış yüzüdür ve bir şey iddia ederse ürün onu yapmak ZORUNDADIR:
  //    ❌ "uçtan uca şifreli" · ❌ "%100 doğru" · ❌ "200+ kişi" (taahhüt 50)
  //    ❌ "canlı altyazı" (metin ~15 sn gecikmelidir)
  "landing.heroTagline": "Kurumsal görüntülü toplantı — hesap açmadan, tarayıcıdan.",
  "landing.heroBody":
    "Katılımcı kendisine gönderilen bağlantıyı açar ve toplantıya girer. Kurulum, uzantı ve kayıt yoktur.",
  // ⚠️ Sayı SUNUCUDAN gelir; metne sabitlenmez (Rapor 08 §9 — vaat dili).
  "landing.capacity": "Bu ortamda toplantı başına en fazla {count} katılımcı desteklenir.",
  "landing.ctaJoin": "Davet bağlantımla katıl",
  "landing.ctaHow": "Nasıl çalışır",
  "landing.ctaAdmin": "Yönetici girişi",
  "landing.pasteTitle": "Davet bağlantınızı yapıştırın",
  "landing.pasteLabel": "Davet bağlantısı",
  "landing.pastePlaceholder": "https://…/j/…#s=…",
  "landing.pasteHint":
    "Bağlantının tamamını yapıştırın — “#” işaretinden sonraki bölüm de gereklidir.",
  "landing.pasteSubmit": "Toplantıya git",
  "landing.pasteInvalid": "Bu metin bir Centvox davet bağlantısına benzemiyor.",
  "landing.howTitle": "Nasıl çalışır",
  "landing.how1Title": "Düzenleyici toplantıyı açar",
  "landing.how1Body":
    "Yönetici panelinden toplantı oluşturulur ve iki bağlantı üretilir: biri katılımcılar, biri host için.",
  "landing.how2Title": "Katılımcı bağlantıyı açar",
  "landing.how2Body":
    "Hesap, parola ve kurulum istenmez. Kamera ile mikrofon toplantıya girmeden önce kontrol edilir.",
  "landing.how3Title": "Görüşme başlar",
  "landing.how3Body":
    "Görüntü ve ses tarayıcıdan akar; sohbet, ekran paylaşımı ve el kaldırma aynı ekrandadır.",
  "landing.featTitle": "Yetenekler",
  "landing.feat1Title": "Bekleme odası ve PIN",
  "landing.feat1Body":
    "Toplantıya kimin gireceğine host karar verir. İsteğe bağlı olarak altı haneli PIN eklenebilir.",
  "landing.feat2Title": "Ekran paylaşımı",
  "landing.feat2Body":
    "Masaüstü tarayıcılarda pencere veya sekme paylaşılır. iOS'ta tarayıcı ekran paylaşımına izin vermez ve arayüz bunu gizlemeden söyler.",
  "landing.feat3Title": "Sohbet ve dosya",
  "landing.feat3Body":
    "Toplantı içi sohbet, bahsetme ve dosya eki. Ekler yüklendikten sonra taranır; tarama bitmeden açılamaz.",
  "landing.feat4Title": "Arka plan ve gürültü",
  "landing.feat4Body":
    "Arka plan bulanıklaştırma ve gürültü engelleme. Cihaz yetişemezse efekt kendiliğinden düşürülür; görüntü donmaz.",
  "landing.feat5Title": "Akan transkript",
  "landing.feat5Body":
    "İsteğe bağlı olarak konuşulanlar metne çevrilir. Metin yaklaşık 15 saniye gecikmeyle görünür ve kapsama oranı raporlanır.",
  "landing.feat6Title": "Yoklama ve dışa aktarma",
  "landing.feat6Body":
    "Kimin ne kadar kaldığı CSV veya JSON olarak indirilir; transkript ve özet ayrı dosyalar hâlinde alınır.",
  "landing.secTitle": "Güvenlik ve gizlilik",
  "landing.sec1": "Görüşme trafiği aktarım sırasında DTLS-SRTP ile şifrelenir.",
  "landing.sec2":
    "Davet sırrı adresin “#” işaretinden sonrasında taşınır; tarayıcı bu bölümü sunucuya göndermez.",
  "landing.sec3":
    "Transkript açıksa katılımcıdan önce izin istenir; reddeden kişinin sesi işlenmez.",
  "landing.sec4":
    "Yoklama raporlarında IP adresi yer almaz; raporu kimin indirdiği denetim kaydına yazılır.",
  "landing.footerNote": "Centvox — hesap gerektirmeyen kurumsal görüntülü toplantı.",
  "landing.footerNav": "Alt bilgi bağlantıları",
  "landing.footerAdmin": "Yönetici paneli",
  "landing.footerUsage": "Kullanım ve maliyet",

  // ── Yönetici konsolu ───────────────────────────────────────────────────
  // ⚠️ Engel mesajları "hata oluştu" DEMEZ: her biri NEYİN eksik olduğunu ve
  //    NEREDE düzeltileceğini söyler. Üç ayrı kurulum eksikliği kullanıcıya
  //    aynı görünür ve çözümleri tamamen farklıdır (bkz. `diagnostics.ts`).
  "admin.title": "Yönetici paneli",
  "admin.subtitle":
    "Toplantı oluşturma ve yönetim. Erişim, kurumunuzun kimlik sağlayıcısı üzerinden Cloudflare Access ile doğrulanır.",
  "admin.checking": "Erişim durumu kontrol ediliyor…",
  "admin.ready": "Yönetici erişiminiz doğrulandı.",
  "admin.blockApiOrigin":
    "İstek arka uca hiç ulaşmadı: bu sayfa API isteğini kendi adresine yaptı ve JSON yerine HTML aldı. Paket doğru API köküyle (VITE_API_ORIGIN) yeniden derlenmelidir. Bu bir CORS sorunu değildir.",
  "admin.blockNetwork":
    "Sunucuya ulaşılamadı. Bunun olağan nedeni CORS ayarının “*” olmasıdır: kimlik bilgisi taşıyan istekler “*” ile gönderilemez. Worker'da CORS_ORIGINS değerine bu sayfanın adresi yazılmalıdır.",
  "admin.blockTenant":
    "Bu adres için kurum kaydı bulunamadı. Veritabanındaki organizations tablosuna, API'nin alan adını taşıyan bir satır eklenmelidir.",
  "admin.blockSso":
    "Oturum bulunamadı. Bu alan adı için bir Cloudflare Access uygulaması tanımlanmalı; kurum kaydına access_issuer ve access_aud değerleri yazılmalıdır.",
  "admin.blockDomain": "Hesabınızın e-posta alan adı bu kurum için izinli değil.",
  "admin.blockForbidden": "Bu işlem için yetkiniz yok.",
  "admin.blockQuota": "Aylık kullanım kotası doldu; yeni toplantı açılamıyor.",
  "admin.howLogin": "Nasıl giriş yapılır?",
  "admin.howLoginBody":
    "Centvox'ta yönetici parolası yoktur. Bu sayfa açıldığında Cloudflare Access sizi kurumunuzun kimlik sağlayıcısına yönlendirir; doğrulamadan sonra panel kendiliğinden açılır. Giriş formu göstermemek bilinçli bir karardır — ikinci ve daha zayıf bir kimlik yüzeyi açmamak için.",
  "admin.createTitle": "Yeni toplantı",
  "admin.fieldTitle": "Toplantı başlığı",
  "admin.fieldStart": "Planlanan başlangıç (isteğe bağlı)",
  "admin.fieldMax": "Azami katılımcı",
  "admin.fieldTranscript": "Transkript / AI",
  "admin.transcriptOff": "Kapalı",
  "admin.transcriptOnDemand": "İstek üzerine (host başlatır)",
  "admin.transcriptAuto": "Otomatik (toplantıyla başlar)",
  "admin.transcriptHint":
    "Kapalı dışındaki seçeneklerde katılımcılara rıza sorulur; reddedenlerin sesi yazıya dökülmez.",
  "admin.create": "Toplantı oluştur",
  "admin.creating": "Oluşturuluyor…",
  "admin.createdTitle": "Toplantı oluşturuldu",
  "admin.createdWarning":
    "Bu bağlantılar yalnız bir kez gösterilir. Sayfayı kapatmadan önce kopyalayın; sunucu bunları geri veremez.",
  "admin.guestLink": "Katılımcı bağlantısı",
  "admin.hostLink": "Host bağlantısı",
  "admin.listTitle": "Toplantılar",
  "admin.listEmpty": "Henüz toplantı oluşturulmadı.",
  "admin.purge": "Kalıcı olarak imha et",
  "admin.purgeQueued": "İmha kuyruğa alındı",
  "admin.purgeFailed": "İmha isteği gönderilemedi.",
  "admin.purgeConfirmTitle": "Bu toplantı kalıcı olarak imha edilsin mi?",
  "admin.purgeConfirmBody":
    "“{title}” toplantısının kaydı, sesi, transkripti ve dosyaları kalıcı olarak silinir. Bu işlem geri alınamaz.",
  // ⚠️ Bilinen sınır gizlenmez: "veri okunamaz hâle gelir" doğrudur,
  //    "depolama geri kazanılır" değildir (D1 VACUUM desteklemez).
  "admin.purgeNote":
    "İmha kuyrukta yürür ve birkaç dakika sürebilir. Hukuki muhafaza altındaki toplantılar imha edilemez.",
  "admin.colTitle": "Başlık",
  "admin.colStatus": "Durum",
  "admin.colStart": "Başlangıç",
  "admin.usageLink": "Kullanım ve tahmini maliyet panelini aç",

  // ── Rol ayrımı (migration 0007) ────────────────────────────────────────
  // ⚠️ Rol arayüzde GÖSTERİLİR: kullanıcı hangi yetkiyle baktığını bilmezse,
  //    eksik bir listeyi arıza sanar.
  "admin.roleOrgAdmin": "Kurum yöneticisi",
  "admin.roleMember": "Toplantı düzenleyici",
  "admin.devBypass": "Yerel geliştirme oturumu",
  "admin.memberScopeHint": "Yalnız kendi oluşturduğunuz toplantıları görüyorsunuz.",
  // ── Durum sekmesi — toplantı düzenleyicisi sürümü ──────────────────────
  "admin.myStatusTitle": "Durumunuz",
  "admin.myEmail": "Hesap",
  "admin.myRole": "Rol",
  "admin.myLiveNow": "Şu an canlı toplantınız",
  "admin.myThisMonth": "Bu ay oluşturduklarınız",
  "admin.myTotal": "Toplam toplantınız",
  // ⚠️ Kapsam açıkça söylenir: kullanıcı kurum genelini gördüğünü sanmamalı.
  "admin.myScopeNote":
    "Bu sayılar yalnız sizin oluşturduğunuz toplantıları kapsar; kurum geneli rakamları yöneticiler görür.",
  "admin.adminScopeHint": "Kurum yöneticisi olarak kurumdaki tüm toplantıları görüyorsunuz.",
  "admin.usersTitle": "Kurum kullanıcıları",
  "admin.ssoOperatorOnly":
    "SSO ayarları operatör tarafından yönetilir. Kimlik sağlayıcınızı bağlamak için platform yöneticisiyle iletişime geçin — kimlik doğrulamanın güven kökü olduğu için bu alan kurum panelinden değiştirilemez.",
  // ── Yönetici yönetimi (ekle / sil / devir) ─────────────────────────────
  "admin.addHost": "Yönetici ekle",
  "admin.addHostEmail": "E-posta adresi",
  /**
   * ⚠️ Alan adı kuralı ÖNCEDEN söylenir. Sunucu kurum dışı adresi reddeder;
   *    kullanıcıyı reddedilecek bir işleme sokup sonra açıklamak, baştan
   *    söylemekten kötüdür.
   */
  "admin.addHostHint": "Yalnız kurumun izin verilen alan adlarındaki adresler eklenebilir.",
  "admin.addHostAsAdmin": "Kurum yöneticisi olarak ekle",
  "admin.hostAdded": "Yönetici eklendi ve erişim listesi güncellendi.",
  "admin.deleteHost": "Sil",
  "admin.deleteHostTitle": "Yöneticiyi sil",
  "admin.deleteHostBody": "{email} kalıcı olarak silinecek. Bu işlem geri alınamaz.",
  "admin.cannotDeleteSelf": "Kendi hesabınızı silemezsiniz.",
  "admin.reassignTo": "Toplantıları devret",
  "admin.reassignNone": "Devretme (toplantısı yoksa)",
  /**
   * ⚠️ Metin, devrin NEDEN gerekebileceğini söyler. Yalnız "seçin" demek,
   *    kullanıcının boş bırakıp hata almasına ve sebebini anlamamasına yol
   *    açardı.
   */
  "admin.reassignHint":
    "Bu yöneticinin toplantıları varsa devralacak birini seçmelisiniz; toplantı kayıtları silinmez.",
  "admin.hostDeleted": "Yönetici silindi.",
  "admin.hostDeletedReassigned": "Yönetici silindi; {n} toplantı devredildi.",
  /**
   * ⚠️ Uyarı "eklendi ama giremeyebilir" der. Sessiz kalmak, giremeyecek
   *    birinin eklendiğini gizlemek olurdu.
   */
  "admin.accessSyncFailed":
    "İşlem kaydedildi ama Cloudflare Access erişim listesi güncellenemedi; kullanıcı giriş yapamayabilir.",

  // ── SSO sağlığı ────────────────────────────────────────────────────────
  "admin.ssoNotConfigured": "SSO yapılandırılmamış; geçici operatör girişi kullanılıyor.",
  "admin.ssoHealthy": "SSO etkin ve Access uygulaması yerinde.",
  /** ⚠️ "bilinmiyor" ≠ "bozuk": ulaşılamayan bir API sağlam SSO'yu bozuk göstermemeli. */
  "admin.ssoUnknown": "SSO etkin; Access uygulamasının durumu şu an doğrulanamadı.",
  "admin.ssoLockedOut":
    "SSO etkin ama Access uygulaması bulunamadı — kurum panele giremez. Onarım gerekiyor.",
  "admin.ssoRepairNeedsToken":
    "Otomatik onarım için CF_ACCESS_TOKEN ve CF_ACCESS_TEAM_DOMAIN tanımlanmalı.",
  "admin.colEmail": "E-posta",
  "admin.colRole": "Rol",
  "admin.colState": "Durum",
  "admin.colActions": "İşlem",
  "admin.colTranscript": "Transkript",
  "admin.untitledMeeting": "(başlıksız toplantı)",
  "invite.guestTitle": "Katılımcılara gönderilecek mesaj",
  "invite.guestHint": "Bu metni olduğu gibi kopyalayıp katılımcılara gönderin.",
  "invite.hostTitle": "Host için mesaj",
  "invite.hostHint":
    "Bu bağlantı toplantıyı yönetme yetkisi verir; yalnız toplantıyı yönetecek kişiye gönderin.",
  "invite.copyMessage": "Mesajı kopyala",
  "invite.whenLabel": "Tarih ve saat",
  "invite.linkLabel": "Katılım bağlantısı",
  "invite.hostLinkLabel": "Host bağlantısı",
  "invite.guestGreeting": "\u201c{title}\u201d toplantısına davetlisiniz.",
  "invite.hostGreeting": "\u201c{title}\u201d toplantısını siz yöneteceksiniz.",
  "invite.guestHowTo":
    "Bağlantıyı tarayıcınızda açmanız yeterli. Hesap açmanıza, uygulama kurmanıza veya eklenti yüklemenize gerek yok. Girmeden önce kameranızı ve mikrofonunuzu kontrol edebilirsiniz.",
  "invite.hostHowTo":
    "Bağlantıyı tarayıcınızda açın. Toplantıyı başlatmak, katılımcıları kabul etmek ve toplantıyı bitirmek yalnız bu bağlantıyla mümkündür.",
  "invite.hostWarning": "Bu bağlantıyı paylaşmayın: açan herkes host yetkisiyle girer.",
  "invite.rawLinks": "Yalnız bağlantılar",
  "admin.statusScheduled": "Planlandı",
  "admin.statusLive": "Devam ediyor",
  "admin.statusEnded": "Bitti",
  "admin.statusCancelled": "İptal edildi",
  "admin.statusUnknown": "Bilinmiyor",
  "admin.viewTranscript": "Transkript",
  "admin.transcriptTitle": "Toplantı transkripti",
  "admin.transcriptLoading": "Transkript yükleniyor…",
  "admin.transcriptNone": "Bu toplantı için transkript yok. Transkript hiç açılmamış olabilir.",
  "admin.transcriptPending": "Transkript hâlâ hazırlanıyor. Birkaç dakika sonra tekrar bakın.",
  "admin.transcriptFailed": "Transkript alınamadı.",
  "admin.transcriptLines": "{count} satır",
  "admin.transcriptMore": "Yalnız ilk bölüm gösteriliyor. Tamamı için .md veya .vtt indirin.",
  "admin.colOutput": "Çıktı",
  "admin.stateActive": "Aktif",
  "admin.stateDisabled": "Pasif",
  "admin.promote": "Yönetici yap",
  "admin.demote": "Yöneticiliği al",
  "admin.disable": "Pasifleştir",
  "admin.enable": "Aktifleştir",
  "admin.you": "siz",
  "admin.lastAdminWarning":
    "Kurumda tek aktif yönetici kaldı. Son yönetici düşürülemez veya pasifleştirilemez; önce başka birini yönetici yapın.",

  // ── Yönetici paneli: kabuk ve giriş ────────────────────────────────────
  "admin.backHome": "Ana sayfa",
  "admin.signOut": "Çıkış",
  /**
   * ⚠️ Kullanıcıya "çıkış yapıldı" DENMEZ: jeton iptal edilemediyse hâlâ
   *    geçerlidir. Yanlış bir güvence, paylaşılan bir bilgisayarda gerçek
   *    zarara dönüşür.
   */
  "admin.signOutFailed":
    "Yerel oturum kapatıldı ama sunucudaki jeton iptal EDİLEMEDİ ve süresi dolana kadar geçerli kalabilir. Bağlantınızı kontrol edip tekrar çıkış yapın; paylaşılan bir bilgisayardaysanız tarayıcıyı tamamen kapatın.",
  // ── Operatör paneli (`/operator`) ──────────────────────────────────────
  // ⚠️ Ayrı bir anahtar öneki: bu metinler müşteri panelinde HİÇ görünmez.
  //    Ortak önek kullanmak, iki panelin metinlerini zamanla birbirine
  //    karıştırırdı.
  "admin.sectionSso": "Kimlik doğrulama (SSO)",
  "operator.title": "Operatör paneli",
  "operator.loginTitle": "Operatör girişi",
  "operator.loginBody":
    "Bu panel platformun kendisini yönetir: kurum açma, SSO bağlama ve operatör yetkileri. Kurumunuzun toplantılarını yönetmek için yönetici paneline gidin.",
  "operator.loginCta": "Kurumsal hesapla giriş yap",
  "operator.ssoNotConfigured":
    "Operatör SSO'su yapılandırılmamış. Zero Trust'ta operatör paneline ayrı bir Access uygulaması tanımlanmalı ve OPERATOR_ACCESS_AUD değeri girilmelidir.",
  "operator.bootstrapTitle": "İlk operatörü oluştur (acil durum)",
  "operator.bootstrapHint":
    "Yalnız hiç operatör yokken gerekir. Bu bir giriş değildir: kaydı açar, sonra SSO ile girersiniz. Her kullanım denetim kaydına ayrı bir satır olarak yazılır.",
  "operator.bootstrapEmail": "Operatör e-postası",
  "operator.bootstrapSubmit": "Kaydı oluştur",
  "operator.bootstrapDone": "Operatör kaydı hazır. Şimdi kurumsal hesapla giriş yapabilirsiniz.",
  "operator.bootstrapFailed": "Kayıt oluşturulamadı. Anahtar veya e-posta hatalı.",
  "operator.tabOrgs": "Kurumlar",
  "operator.tabOperators": "Operatörler",
  "operator.orgsTitle": "Kurumlar",
  "operator.orgsEmpty": "Henüz kurum açılmadı.",
  "operator.colOrg": "Kurum",
  "operator.colHostname": "Alan adı",
  "operator.colPlan": "Plan",
  "operator.colSso": "SSO",
  "operator.ssoOn": "Bağlı",
  "operator.ssoOff": "Bağlı değil",
  "operator.createTitle": "Yeni kurum",
  "operator.createIntro":
    "Kurum kaydedilmeden önce ona ait bir SFU uygulaması otomatik oluşturulur. Her kurumun kendi uygulaması olması zorunludur: yayın kanalları uygulama genelinde ortaktır, yani izolasyon sınırı uygulamadır.",
  "operator.fieldSlug": "Kısa ad",
  "operator.fieldSlugHint":
    "Yalnız küçük harf, rakam ve tire. Kaynak adlarına girer ve SONRADAN DEĞİŞTİRİLEMEZ.",
  "operator.fieldName": "Kurum adı",
  "operator.fieldAdmin": "İlk yöneticinin e-postası",
  "operator.fieldAdminHint":
    "Bu adres kurumun açılış yöneticisidir: ilk giriş yaptığında kurum yöneticisi olarak açılır.",
  "operator.fieldHostname": "API alan adı (isteğe bağlı)",
  "operator.fieldHostnameHint":
    "Verilirse kiracı çözümlemesi bu adrese bağlanır ve SSO otomatik kurulur. Boş bırakılırsa kurum ortak adres üzerinden çalışır ve SSO kurulamaz.",
  "operator.create": "Kurumu oluştur",
  "operator.creating": "Oluşturuluyor…",
  "operator.createdTitle": "Kurum oluşturuldu",
  // ⚠️ "Oluşturuldu" ≠ "hazır": eksik adımlar açıkça sayılır.
  "operator.pending": "Henüz tamamlanmayan adımlar:",
  "operator.operatorsTitle": "Operatörler",
  "operator.operatorsIntro":
    "Operatörler platformdan sorumludur: kurum açar, SSO bağlar ve birbirlerini yönetir. Kurumların toplantılarına erişmezler.",
  "operator.addEmail": "Yeni operatör e-postası",
  "operator.addEmailHint":
    "Bu adres, operatör Access uygulamasından giriş yapabildiğinde tanınır. Eklemek tek başına giriş hakkı vermez.",
  "operator.add": "Operatör ekle",
  "operator.added": "Operatör eklendi.",
  "operator.colEmail": "E-posta",
  "operator.colState": "Durum",
  "operator.colAction": "İşlem",
  "operator.stateActive": "Aktif",
  "operator.stateOff": "Pasif",
  // ⚠️ "Sil" DENMEZ: satır silinmez, pasifleştirilir — denetim kaydındaki
  //    atıf korunmalıdır.
  "operator.disable": "Pasifleştir",
  "admin.sections": "Panel bölümleri",
  "admin.tabStatus": "Durum",
  "admin.tabMeetings": "Toplantılar",
  "admin.tabUsers": "Kullanıcılar",
  "admin.tabOrg": "Kurum",
  "admin.loginTitle": "Yönetici girişi",
  "admin.loginEmail": "E-posta adresiniz",
  "admin.loginKey": "Operatör anahtarı",
  "admin.loginKeyHint": "Kurulumu yapan kişiden alınır. Tarayıcıya kaydedilmez.",
  "admin.login": "Giriş yap",
  "admin.loggingIn": "Giriş yapılıyor…",
  // ⚠️ Tek mesaj: "anahtar yanlış" ile "bu e-posta yetkili değil" ayrımı,
  //    yönetici e-postalarını numaralandıran bir kanal açardı.
  "admin.loginFailed": "E-posta veya anahtar hatalı.",
  "admin.loginOrg": "Kurum: {name}",
  "admin.loginDisabled":
    "Bu kurumda geçici giriş kapalı. Operatör anahtarı tanımlı değil veya SSO devrede.",
  // ⚠️ Zayıflık dipnotta değil, ekranın başında.
  "admin.interimNotice":
    "Bu geçici bir giriş yöntemidir ve kurumsal SSO'dan zayıftır: paylaşılan bir anahtar kullanır, çok adımlı doğrulama yoktur. Özel alan adı alınıp Cloudflare Access kurulduğunda bu yol kendiliğinden kapanır.",
  "admin.ssoTitle": "Kurumsal oturum gerekiyor",
  "admin.ssoLogin": "Kurumsal hesapla giriş yap",
  "admin.ssoBody":
    "Bu kurumda Cloudflare Access devrede. Kimlik sağlayıcınızda oturum açtıktan sonra bu sayfa kendiliğinden açılır.",

  // ── Yönetici paneli: durum ─────────────────────────────────────────────
  "admin.sectionStats": "Özet",
  "admin.sectionCapabilities": "Platform yetenekleri",
  "admin.sectionLive": "Canlı odalar",
  "admin.sectionUnmeasured": "Ölçülemeyenler",
  "admin.sectionAudit": "Son denetim kayıtları",
  "admin.sectionOrg": "Kurum ayarları",
  "admin.statRoomsLive": "canlı oda",
  "admin.statParticipants": "anlık katılımcı",
  "admin.statRoomsStale": "bayat kayıt",
  "admin.statMeetings": "toplam toplantı",
  "admin.statScheduled": "planlanmış",
  "admin.statHosts": "kullanıcı",
  "admin.statAdmins": "kurum yöneticisi",
  "admin.statDisabled": "pasif hesap",
  "admin.healthReady": "hazır",
  "admin.healthUnavailable": "kapalı",
  "admin.healthUnknown": "ölçülemiyor",
  "admin.generatedAt": "Son güncelleme {time}.",
  "admin.refresh": "Yenile",
  "admin.liveEmpty": "Şu anda canlı oda yok.",
  "admin.liveStreaming": "canlı",
  "admin.liveStalled": "bağlantı yok",
  "admin.colMeeting": "Toplantı",
  "admin.colParticipants": "Katılımcı",
  "admin.colStarted": "Başlangıç",
  "admin.colHeartbeat": "Kalp atışı",
  // ⚠️ "Canlı" yazan ama kalp atışı gelmeyen satır canlı DEĞİLDİR.
  "admin.freshRoom": "{sec} sn önce",
  "admin.staleRoom": "{sec} sn — bayat, oda kapanmış olabilir",
  "admin.auditNotice":
    "Denetim kaydında kişisel veri yer almaz; kimlikler takma addır. Bu listeyi açmak da denetime yazılır.",
  "admin.auditEmpty": "Henüz denetim kaydı yok.",

  // ── Yönetici paneli: kurum ayarları ────────────────────────────────────
  "admin.save": "Kaydet",
  "admin.saved": "Kaydedildi.",
  "admin.saveFailed": "Kaydedilemedi.",
  "admin.transcriptE2ee": "E2EE açık — transkript alınamaz",
  "admin.viewSummary": "Özet",
  "admin.summaryTitle": "Toplantı özeti",
  "admin.summaryLoading": "Özet yükleniyor…",
  "admin.summaryNone": "Bu toplantı için özet üretilmedi. Transkript hiç açılmamış olabilir.",
  "admin.summaryPending": "Özet hâlâ hazırlanıyor. Birkaç dakika sonra tekrar bakın.",
  "admin.summaryFailed": "Özet alınamadı.",
  "admin.summaryCoverage": "Transkript kapsaması: %{pct}",
  "admin.summaryDecisions": "Kararlar",
  "admin.summaryActions": "Aksiyonlar",
  "admin.summaryModel": "Model: {model}",
  "admin.downloadTranscriptMd": "Transkript (.md)",
  "admin.downloadTranscriptVtt": "Transkript (.vtt)",
  "admin.downloadSummaryMd": "Özet (.md)",
  "admin.fieldDomains": "İzinli e-posta alan adları",
  "admin.fieldDomainsHint": "Virgülle ayırın. Örnek: sirket.com, sirket.com.tr",
  "admin.fieldAdminEmails": "Açılış yöneticileri",
  // ⚠️ Yalnız İLK kayıtta uygulandığı açıkça yazılır; yazılmazsa yönetici
  //    listeye eklediği kişinin yönetici olacağını sanır.
  "admin.fieldAdminEmailsHint":
    "Virgülle ayırın. Bu liste yalnızca kişinin İLK girişinde uygulanır; mevcut kullanıcıların rolü Kullanıcılar sekmesinden değiştirilir.",
  "admin.fieldOperatorKey": "Operatör anahtarı",
  "admin.fieldOperatorKeyHint":
    "Bu değişiklik oturumunuzla değil, operatör anahtarıyla doğrulanır — kilitlenme durumunda geri dönüş yolu budur.",
  "admin.ssoEnable": "SSO'yu etkinleştir",
  "join.title": "Toplantıya katıl",
  "join.nameLabel": "Görünen adınız",
  "join.namePlaceholder": "Adınız",
  "join.pinLabel": "Toplantı PIN'i",
  "join.submit": "Katıl",
  "join.submitting": "Katılınıyor…",
  "join.lobbyNotice": "Bu toplantıda bekleme odası açık; host onayı gerekir.",
  "join.invalidLink": "Katılım bağlantısı geçersiz. Lütfen davet linkini yeniden açın.",
  "join.missingSecret": "Katılım bağlantısı eksik. Davet linkinin tamamını kullanın.",
  "join.notFound": "Toplantı bulunamadı.",
  "join.failed": "Katılım başarısız oldu.",
  "join.ended": "Bu toplantı sona erdi.",
  "join.full": "Toplantı kapasitesi dolu.",
  "join.inviteExhausted": "Davet bağlantısı geçersiz veya kullanılmış.",
  "join.pinWrong": "PIN hatalı.",
  "join.turnstileUnconfigured":
    "Bot koruması bu ortamda yapılandırılmamış; katılım kabul edilemiyor. Yöneticinize bildirin.",
  "join.turnstileUnreachable":
    "Doğrulama servisine ulaşılamadı. Reklam engelleyici veya ağ filtresi challenges.cloudflare.com adresini engelliyor olabilir.",
  "join.turnstileFailed": "Doğrulama tamamlanamadı. Lütfen tekrar deneyin.",
  "join.encryptionNotice": "Görüşmeniz aktarım sırasında DTLS-SRTP ile şifrelenir.",

  // ── Green room ─────────────────────────────────────────────────────────
  "green.title": "Cihazlarınızı kontrol edin",
  "green.camera": "Kamera",
  "green.microphone": "Mikrofon",
  "green.speaker": "Hoparlör",
  "green.noCamera": "Kamera bulunamadı",
  "green.noMicrophone": "Mikrofon bulunamadı",
  "green.permissionNeeded": "Kamera ve mikrofon izni gerekiyor.",
  "green.permissionDenied":
    "İzin verilmedi. Tarayıcı ayarlarından kamera ve mikrofon iznini açabilirsiniz.",
  /**
   * ⚠️ Bu üç mesaj, önceden "izin verilmedi" diye gösterilen durumlardır.
   *    Kullanıcıyı yanlış ayara göndermek, hatanın kendisinden pahalıydı.
   */
  "green.deviceBusy":
    "Kamera veya mikrofon başka bir uygulama tarafından kullanılıyor. Diğer uygulamayı kapatıp yeniden deneyin.",
  "green.deviceUnsupported":
    "Tarayıcı kamera ve mikrofona erişemiyor. Sayfanın HTTPS üzerinden açıldığından emin olun.",
  "green.deviceFailed": "Cihaz açılamadı. Kamera kapalı katılabilir veya yeniden deneyebilirsiniz.",
  "green.joinMuted": "Mikrofon kapalı katıl",
  "green.joinWithCameraOff": "Kamera kapalı katıl",
  "green.micLevel": "Mikrofon seviyesi",
  "green.speakNow": "Konuşun — çubuk hareket etmeli.",

  // ── Lobi ───────────────────────────────────────────────────────────────
  "lobby.waiting": "Host'un sizi kabul etmesi bekleniyor…",
  "lobby.cancel": "Beklemeyi bırak",
  "lobby.denied": "Katılım isteğiniz reddedildi.",
  "lobby.knockTitle": "Bekleyenler",
  "lobby.admit": "Kabul et",
  "lobby.deny": "Reddet",
  "lobby.admitAll": "Hepsini kabul et",
  // ⚠️ Türkçede de `one` kategorisi VARDIR (CLDR: i = 0..1) — yalnız `_other`
  //    yazmak 1 kişilik durumda yanlış cümle üretir.
  "lobby.empty_one": "{count} kişi bekliyor",
  "lobby.empty_other": "{count} kişi bekliyor",

  // ── Oda ────────────────────────────────────────────────────────────────
  "room.participants": "Katılımcılar",
  "room.chat": "Sohbet",
  "room.controls": "Toplantı kontrolleri",
  "room.micOn": "Mikrofonu aç",
  "room.forcedMuteMic": "Moderatör mikrofonunuzu kapattı.",
  "room.forcedMuteCam": "Moderatör kameranızı kapattı.",
  "room.forcedMuteScreen": "Moderatör ekran paylaşımınızı kapattı.",
  "room.screenDenied": "Ekran paylaşma yetkiniz yok.",
  "room.screenPublishFailed": "Ekran paylaşımı başlatılamadı; yakalama durduruldu.",
  "room.reconnectStalled":
    "Baglanti kurulamiyor. Denemeye devam ediliyor; sayfayi yenilemenize gerek yok.",
  "room.camPublishFailed": "Kamera yayına alınamadı; kamera kapatıldı.",
  "room.noPublishCap": "Yayın yapma yetkiniz yok.",
  "room.micOff": "Mikrofonu kapat",
  "room.camOn": "Kamerayı aç",
  "room.camOff": "Kamerayı kapat",
  "room.screenShare": "Ekran paylaş",
  "room.screenStop": "Paylaşımı durdur",
  "room.raiseHand": "El kaldır",
  "room.lowerHand": "Eli indir",
  "room.leave": "Ayrıl",
  "room.leaveConfirm": "Toplantıdan ayrılmak istediğinize emin misiniz?",
  "room.muted": "sessiz",
  /* ── Durum rayı ───────────────────────────────────────────────────────
     ⚠️ "Kaydediliyor" DEĞİL "Transkript alınıyor": ürün video/ses kaydı
        tutmuyor, sesi metne çeviriyor. Yanlış kelime, kullanıcıya var
        olmayan bir kayıt dosyası olduğunu düşündürürdü. */
  "room.recording": "Transkript alınıyor",
  "room.elapsed": "Toplantı süresi",
  "room.peopleCount": "{count} kişi",
  "room.linkGood": "Bağlantı iyi",
  "room.linkWeak": "Bağlantı zayıf",
  "room.linkLost": "Bağlantı yok",
  "room.you": "siz",
  "room.host": "host",
  "room.cohost": "yardımcı host",
  "room.presenter": "sunucu",
  "room.viewer": "izleyici",
  "room.handRaised": "el kaldırdı",
  "room.remoteMediaStalled":
    "Karşı taraftan görüntü/ses gelmiyor. Bağlantıları yenilemek için sayfayı yenileyin.",
  "room.reconnecting": "Yeniden bağlanılıyor…",
  "room.ended": "Bu toplantı sona ermiştir",
  "room.endedBody":
    "Host toplantıyı bitirdi. Bu bağlantı artık kullanılamaz; yeni bir toplantı bağlantısı gerekir.",
  "room.endedLeave": "Ana sayfaya dön",
  "room.endedRedirect": "{count} saniye içinde ana sayfaya yönlendirileceksiniz.",
  "room.endMeeting": "Toplantıyı bitir",
  "room.endConfirm":
    "Toplantı herkes için sona erecek ve odadaki {count} kişinin bağlantısı kesilecek. Bu işlem geri alınamaz.",
  "room.locked": "Toplantı kilitlendi; yeni katılım kapalı.",
  "room.isOver": "Bu toplantı sona ermiştir. Bu bağlantı artık kullanılamaz.",
  "room.unlocked": "Toplantı kilidi açıldı.",
  "room.screenUnsupported": "Bu cihazda ekran paylaşımı desteklenmiyor.",
  "room.removed": "Toplantıdan çıkarıldınız.",
  "room.participants_one": "{count} katılımcı",
  "room.participants_other": "{count} katılımcı",

  // ── Sohbet ─────────────────────────────────────────────────────────────
  "chat.placeholder": "Mesaj yazın…",
  "chat.noSendCap": "Bu toplantıda mesaj yazma yetkiniz yok.",
  "chat.send": "Gönder",
  "chat.empty": "Henüz mesaj yok.",
  "chat.edited": "düzenlendi",
  "chat.deleted": "Bu mesaj silindi.",
  "chat.edit": "Düzenle",
  "chat.delete": "Sil",
  "chat.loadOlder": "Daha eski mesajlar",
  "chat.disabled": "Bu toplantıda sohbet kapalı.",
  "chat.externalLink": "Harici bağlantı",
  "chat.mentionedYou": "Sizden bahsedildi",
  "chat.pin": "Sabitle",
  "chat.unpin": "Sabitlemeyi kaldır",

  // ── Ekler (F1-26/F2-22) ────────────────────────────────────────────────
  // ⚠️ "Taranıyor" metni GİZLENMEZ: dosya hemen açılamayacaksa kullanıcı
  //    bunun bir arıza değil, bir güvenlik adımı olduğunu bilmelidir.
  "chat.attach": "Dosya ekle",
  "chat.attachments": "Ekler",
  "chat.typing": "{names} yazıyor…",
  "chat.attachedImage": "Eklenen görsel",
  "chat.showImage": "Görseli göster",
  "chat.download": "İndir",
  "chat.scanning": "Taranıyor — birazdan açılabilir.",
  "chat.attachBlocked": "Bu dosya zararlı olarak işaretlendi.",
  "chat.attachFailed": "Dosya yüklenemedi.",
  "chat.attachTooLarge": "Dosya çok büyük.",
  "chat.attachTooMany": "En fazla 5 ek gönderebilirsiniz.",
  "chat.attachTypeNotAllowed": "Bu dosya türü kabul edilmiyor.",
  "chat.attachEmpty": "Dosya boş.",
  "room.screenTile": "ekran paylaşımı",
  "room.pinTile": "{name} karosunu sabitle",
  "room.unpinTile": "{name} sabitlemesini kaldır",
  "room.tools": "Araçlar",
  "view.title": "Görünüm",
  "view.gallery": "Izgara",
  "view.speaker": "Konuşmacı",
  "view.hideSelf": "Kendi görüntümü gizle",
  "view.hideCamOff": "Kamerası kapalı olanları gizle",
  "device.title": "Cihazlar",
  "device.mic": "Mikrofon",
  "device.camera": "Kamera",
  "device.auto": "Otomatik",
  "device.outputHint":
    "Hoparlör seçimi işletim sisteminin ses ayarlarından yapılır; tarayıcıların bir kısmı bunu sayfaya bırakmaz.",
  "device.switchFailed": "Cihaz değiştirilemedi; başka bir uygulama kullanıyor olabilir.",
  "room.resizePanel": "Panel genişliğini ayarla",
  "react.thumbsUp": "Beğendim",
  "react.clap": "Alkış",
  "react.heart": "Kalp",
  "react.laugh": "Güldüm",
  "react.wow": "Şaşırdım",
  "react.party": "Kutlama",
  "room.more": "Diğer araçlar",
  "room.pages": "Sayfalar",
  "room.prevPage": "Önceki sayfa",
  "room.nextPage": "Sonraki sayfa",
  "room.pageOf": "{page} / {total}",
  "room.react": "Tepki ver",

  // ── Host kontrolleri ───────────────────────────────────────────────────
  "host.mute": "Sustur",
  "host.stopCam": "Kamerayı kapat",
  "host.stopScreen": "Ekranı kapat",
  "host.kick": "Toplantıdan çıkar",
  "host.kickConfirm": "{name} toplantıdan çıkarılsın mı?",
  "host.makeCohost": "Yardımcı host yap",
  "host.transferHost": "Host'luğu devret",
  "host.transferConfirm": "Host'luk {name} kişisine devredilsin mi? Bu geri alınamaz.",
  "host.roomSettings": "Oda ayarları",
  "host.allowScreenAll": "Herkes ekran paylaşabilsin",
  "host.allowScreenHint":
    "Kapatıldığında yalnız host, yardımcı host ve sunucular paylaşabilir. Tek tek izin vermeye devam edebilirsiniz. Kapatmak, o an süren bir paylaşımı durdurmaz.",
  "host.lock": "Toplantıyı kilitle",
  "host.unlock": "Kilidi aç",
  "host.endForAll": "Herkes için bitir",
  "host.endConfirm": "Toplantı herkes için sonlandırılsın mı?",
  "host.grantScreen": "Ekran paylaşımı izni ver",
  "host.revokeScreen": "Ekran paylaşımı iznini geri al",

  // ── Kalite ve durum ────────────────────────────────────────────────────
  "quality.good": "Bağlantı iyi",
  "quality.lowerVideo": "Bağlantınız zayıf — video kalitesi düşürüldü.",
  "quality.audioOnly": "Bağlantınız zayıf — yalnız ses moduna geçiliyor.",
  /**
   * ⚠️ Mesaj **ne olduğunu ve neyin sürdüğünü** birlikte söyler. Yalnız
   *    "HD kapatıldı" demek, kullanıcıya toplantının bozulduğunu düşündürür;
   *    oysa video sürüyor, yalnız çözünürlük indi.
   */
  "quality.hdDowngraded": "Bağlantınız HD için yetersiz — standart kaliteye geçildi.",
  // ── Cihaz hot-plug (F1-18) ─────────────────────────────────────────────
  // ⚠️ "Cihaz değişti" gibi belirsiz bir metin YETMEZ: kullanıcı hangi
  //    cihazın gittiğini bilmezse mikrofonunun kapalı olduğunu fark etmez.
  "device.switched": "Cihazınız değişti — yedek cihaza geçildi.",
  "device.micLost": "Mikrofonunuz çıkarıldı ve yedek bulunamadı — sesiniz gitmiyor.",
  "device.cameraLost": "Kameranız çıkarıldı ve yedek bulunamadı — görüntünüz gitmiyor.",

  "status.audioLocked": "Bu cihazda ses için izin gerekiyor.",
  "status.unlockAudio": "Sesi aç",
  "status.backgroundNotice": "Uygulamayı arka plana aldığınızda görüntü ve ses duraklar.",
  "status.updateReady": "Yeni sürüm hazır.",
  "status.updateNow": "Şimdi güncelle",
  "status.offline": "İnternet bağlantısı yok.",

  // ── Transkript (⚠️ "canlı altyazı" DENMEZ) ─────────────────────────────
  "transcript.title": "Akan transkript",
  "transcript.start": "Transkripti başlat",
  "transcript.stop": "Transkripti durdur",
  "transcript.delayNotice": "Metin yaklaşık 15 saniye gecikmeli görünür.",
  "transcript.consentTitle": "Transkript izni",
  "transcript.consentBody":
    "Mikrofonunuz metne dönüştürülecek. Reddederseniz sesiniz işlenmez ve adınız transkriptte konuşmacı olarak geçmez.",
  "transcript.consentLimit":
    "Aynı ortamdaki başka mikrofonlara karışan sesler tamamen engellenemez.",
  "transcript.consentGranted": "Sesiniz transkripte işleniyor.",
  "transcript.withdraw": "İznimi geri çek",
  "transcript.regrant": "Yeniden izin ver",
  "transcript.consentWithdrawn": "Sesiniz transkripte işlenmiyor.",
  "transcript.accept": "Kabul ediyorum",
  "transcript.decline": "Reddediyorum",
  "transcript.coverage": "Kapsama: %{pct}",
  "transcript.translateTo": "Çeviri",
  "transcript.translateOff": "Kapalı (kaynak dil)",
  "transcript.translating": "Çevriliyor…",
  // ⚠️ "Canlı çeviri" DENMEZ: gecikmeli ve parti parti gelir.
  "transcript.translatePartial": "Çok uzun transkript; yalnız bir bölümü çevrildi.",
  "transcript.translateFailed": "Çeviri alınamadı.",
  "transcript.historyFailed": "Önceki konuşmalar yüklenemedi; yalnız bundan sonrası görünecek.",
  "transcript.search": "Transkriptte ara",
  "transcript.waiting": "Konuşulanlar birkaç saniye içinde burada görünecek.",
  "transcript.inactive": "Transkript kapalı.",
  // ═══════════════ Asistan · moderasyon · çeviri ═══════════════
  // ⚠️ "altyazı" / "canlı çeviri" gibi tutulamayacak sözler VERİLMEZ:
  //    asistan transkriptle sınırlıdır, çeviri istek üzerine ve gecikmelidir.
  "assistant.title": "Toplantı asistanı",
  "assistant.ask": "Sor",
  "assistant.thinking": "Yanıt hazırlanıyor…",
  "assistant.placeholder": "Bu toplantıda ne konuşuldu?",
  "assistant.scopeNotice":
    "Yalnızca bu toplantının transkriptine dayanır; genel bilgi soruları yanıtlanmaz.",
  "assistant.sources": "Kaynaklar",
  "assistant.noSources": "Model kaynak göstermedi; yanıtı transkriptten doğrulayın.",
  "assistant.noTranscript": "Bu toplantı için henüz transkript yok.",
  "assistant.noPermission": "Transkripti görüntüleme yetkiniz yok.",
  "assistant.failed": "Yanıt alınamadı.",
  // ⚠️ "Sonra tekrar deneyin" DEMEZ: kota UTC gece yarısı yenilenir.
  "assistant.quotaSpent":
    "Yardımcı AI için günlük kota doldu. Transkript ve özet çalışmaya devam ediyor.",
  "chat.reportsTitle": "Şikâyet edilen mesajlar",
  "chat.reportsEmpty": "Şikâyet yok.",
  "chat.reportFlagged": "Model sakıncalı buldu",
  "chat.reportClean": "Model sakınca bulmadı",
  "chat.reportPending": "Değerlendiriliyor",
  // ⚠️ "Temiz" DEĞİL: çözülemeyen bir çıktı elle incelenmelidir.
  "chat.reportUnknown": "Değerlendirilemedi — elle inceleyin",
  "chat.report": "Şikâyet et",
  "chat.reported": "Şikâyetiniz moderatörlere iletildi.",
  "chat.reportFailed": "Şikâyet gönderilemedi.",

  // ── Hata ───────────────────────────────────────────────────────────────
  // ── Maliyet paneli (F4-13) ─────────────────────────────────────────────
  // ⚠️ "Tahmini" kelimesi BAŞLIKTA geçer; dipnottaki uyarı okunmaz ve rakam
  //    fatura sanılır (Rapor 08 §9 — bağlayıcı vaat dili).
  "usage.title": "Kullanım ve tahmini maliyet",
  "usage.period": "Dönem",
  "usage.estimatedTotal": "Tahmini toplam",
  "usage.breakdown": "Metrik bazında döküm",
  "usage.metric": "Metrik",
  "usage.amount": "Miktar",
  "usage.source": "Kaynak",
  "usage.confidence": "Güven",
  "usage.priceVersion": "Fiyat sürümü",
  "usage.quota": "Kota kullanımı",
  "usage.hardCapOn": "Sert üst sınır açık — kota dolduğunda yeni toplantı başlatılamaz.",
  "usage.hardCapOff": "Sert üst sınır KAPALI — kota aşımı faturaya yansıyabilir.",
  "usage.srcEstimate": "tahmin",
  "usage.srcApi": "Cloudflare API",
  "usage.srcReconciled": "mutabakatlı",

  "error.rejoinConflict":
    "Bu toplantıda zaten bir yayınınız var. Sayfayı yenileyip yeniden katılın.",
  "error.generic": "Beklenmeyen bir hata oluştu.",
  "error.network": "Sunucuya ulaşılamadı.",
  "error.rateLimited": "Çok fazla istek. Lütfen biraz bekleyin.",
  "error.capabilityDenied": "Bu işlem için yetkiniz yok.",
  "error.planLimit": "Bu özellik mevcut planınıza dahil değil.",
  "error.sessionExpired": "Oturumunuz sona erdi. Sayfayı yenileyin.",
  "error.panelCrashed": "Bu panel yüklenemedi. Görüşmeniz etkilenmedi.",
  "error.appUpdated":
    "Uygulama güncellendi. Bu bölümü görmek için sayfayı yenileyin; toplantıdan çıkmazsınız.",
  "error.refreshPage": "Sayfayı yenile",
  "error.reload": "Paneli yeniden yükle",
  // ⚠️ Kullanıcının hatası DEĞİL: istemci ile sunucu sürümleri uyuşmuyor.
  //    Doğru eylem "yeniden yükle", "daha dikkatli ol" değil.
  "error.clientOutdated": "Bu sayfa güncel değil. Lütfen yeniden yükleyin.",
  "error.staleView": "O kişi toplantıdan çoktan ayrılmış.",

  // ── Klavye ─────────────────────────────────────────────────────────────
  // ── Ekran paylaşım profilleri ──────────────────────────────────────────
  "screen.profileTitle": "Ekran paylaşım kalitesi",
  /**
   * ⚠️ Etiketler **ne için** olduğunu söyler, teknik parametreyi değil.
   *    "8 fps / 1,5 Mbps" kullanıcıya hangi seçeneği seçeceğini söylemez;
   *    "metin ve sunum" söyler.
   */
  "screen.profile.text": "Metin ve sunum — en keskin",
  "screen.profile.motion": "Video ve hareket — akıcı",
  "screen.profile.hd": "HD video — 1080p, 60 fps",
  /**
   * ⚠️ Kulaklık uyarısı etiketin İÇİNDE: `echoCancellation` kapalıyken
   *    hoparlör kullanmak odadaki herkese geri besleme yollar. Uyarıyı ayrı
   *    bir ipucu satırına koymak, yatay şeritte hiç gösterilmemesi demekti.
   */
  "audio.musicMode": "Müzik modu (kulaklık gerekir)",
  "effects.title": "Ses ve görüntü",
  "effects.background": "Arka plan",
  "effects.blurOff": "Kapalı",
  "effects.blurLight": "Hafif bulanık",
  "effects.blurStrong": "Güçlü bulanık",
  "effects.blurUnavailable":
    "Bu cihaz arka plan efektini akıcı çalıştıramıyor; görüntünün donmaması için seçenek gösterilmiyor.",
  "effects.modePrecise": "Kişi kenarları algılanıyor.",
  "effects.modeBasic": "Temel bulanıklık kullanılıyor; kenarlar kaba olabilir.",
  "effects.noise": "Gürültü engelleme",
  "effects.noiseOff": "Kapalı",
  "effects.noiseBrowser": "Standart",
  "effects.noiseEnhanced": "Gelişmiş",
  "effects.noiseOffWarning":
    "Gürültü engelleme kapalıyken hoparlör sesi mikrofona geri girebilir ve yankı oluşur.",
  "effects.noiseFallback":
    "Gelişmiş mod bu kurulumda hazır değil; standart engelleme kullanılıyor.",
  "effects.blurLost": "Cihaz yetişemedi: arka plan bulanıklaştırma KAPANDI. Arkanız görünüyor.",
  "effects.micReacquireFailed":
    "Mikrofon yeniden açılamadı; önceki ayar korundu. Cihazı kontrol edin.",
  "effects.degraded": "Cihaz yetişemediği için arka plan efekti düşürüldü.",
  "keys.title": "Klavye kısayolları",
  "keys.toggleMic": "Mikrofonu aç/kapat",
  "keys.toggleCam": "Kamerayı aç/kapat",
  "keys.toggleChat": "Sohbeti aç/kapat",
  "keys.toggleParticipants": "Katılımcı listesini aç/kapat",
  "keys.raiseHand": "El kaldır/indir",
  "keys.leave": "Toplantıdan ayrıl",
  "keys.help": "Bu yardımı göster",
  // ⚠️ `as const` KULLANILMAZ: değerler literal tipe dönüşürse İngilizce
  //    katalog "'Cancel' is not assignable to 'Vazgeç'" hatası verir.
} satisfies Record<string, string>;
